import { Event } from "..";
import { News } from "..";
import { EVENT_ROUTE } from "shared/config/routes";
import EventImg from "../assets/EventImg.jpg";
import NewsVideo from "../assets/NewsVideo.mp4";
import VideoPoster from "../assets/VideoPoster.JPG";
import styles from "./NewsSection.module.scss";

export const NewsSection = () => {
  return (
    <div className={styles.newsContainer}>
      <div className={styles.newsWrapper}>
        <div className={styles.newsWrapper__events}>
          <p className={styles.newsWrapper__title}>Мероприятия</p>
          <div className={styles.newsWrapper__event}>
            <Event
              eventImg={EventImg}
              eventName="Конгресс «Азбука рубцов. Лечение от А до Я»"
              eventDate="28.05.2026"
              eventLink={EVENT_ROUTE}
            />
          </div>
        </div>
        <div className={styles.newsWrapper__news}>
          <p className={styles.newsWrapper__title}>Новости</p>
          <div className={styles.newsWrapper__newsItem}>
            <News
              newsImg={NewsVideo}
              posterUrl={VideoPoster}
              newsName="Новый испанский бренд"
              newsDate="20.12.2026"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
